import Component_Props_d841789d93a6e79171a05ea7b8225a39 from "../../../../content/examples/models/props/Props";
import Devtool_Props_d841789d93a6e79171a05ea7b8225a39 from "!!@devtool/loader!../../../../content/examples/models/props/Props";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_Props_d841789d93a6e79171a05ea7b8225a39,
  Devtool_Props_d841789d93a6e79171a05ea7b8225a39,
  DevTool,
  React
};